/**
 * Scanlines Module
 * Provides toggle functionality for scanline visual effects
 */

(function() {
  'use strict';

  // Track initialized elements to prevent double-binding
  const _initializedToggles = new WeakSet();

  /**
   * Sets up scanline toggle functionality
   * @param {Object} ctx - Context object containing DOM scope
   */
  function setupScanlineToggle(ctx) {
  const scope = ctx?.root || document;
  
  // Safe no-op if no DOM is available
  if (!scope || typeof scope.querySelectorAll !== 'function') {
    return;
  }
  
  const toggleElements = scope.querySelectorAll('[data-cs-scan-toggle]');

  if (toggleElements.length === 0) {
    return;
  }

  toggleElements.forEach((toggle) => {
    // Skip if already initialized (idempotent)
    if (_initializedToggles.has(toggle)) {
      return;
    }
    
    // Determine if the toggle is a checkbox or button
    const isCheckbox = toggle.type === 'checkbox';
    const eventType = isCheckbox ? 'change' : 'click';

    // Get target selector from data attribute
    const targetSelector = toggle.getAttribute('data-cs-scan-target') || 'body';
    const target = document.querySelector(targetSelector);

    if (!target) {
      // Silent no-op if target not found
      return;
    }

    // Set up the event listener
    toggle.addEventListener(eventType, (event) => {
      handleToggle(event, toggle, target, isCheckbox);
    }, { passive: true });
    
    // Mark as initialized
    _initializedToggles.add(toggle);

    // Initialize state for checkboxes based on their checked property
    if (isCheckbox) {
      if (toggle.checked) {
        target.classList.add('scanlines-active');
      } else {
        target.classList.remove('scanlines-active');
      }
    }
  });
}

  /**
   * Handles toggle event for both buttons and checkboxes
   * @param {Event} event - The event object
   * @param {HTMLElement} toggle - The toggle element
   * @param {HTMLElement} target - The target element to apply scanlines to
   * @param {boolean} isCheckbox - Whether the toggle is a checkbox
   */
  function handleToggle(event, toggle, target, isCheckbox) {
    if (isCheckbox) {
      // For checkboxes, use the checked state
      if (toggle.checked) {
        target.classList.add('scanlines-active');
      } else {
        target.classList.remove('scanlines-active');
      }
    } else {
      // For buttons, toggle the class
      const isActive = target.classList.toggle('scanlines-active');
      toggle.setAttribute('aria-pressed', isActive.toString());
    }

    // Dispatch custom event for other modules to listen to
    const customEvent = new CustomEvent('scanlines:toggle', {
      detail: {
        active: target.classList.contains('scanlines-active'),
        target: target,
      },
      bubbles: true,
    });
    toggle.dispatchEvent(customEvent);
  }

  // Expose module functions
  window.CyberSells_scanlines = {
    setupScanlineToggle
  };

})();
